// JavaScript Document
//components/configuration/PowerInterval.js
import React from 'react';
//import PropTypes from 'prop-types';
//import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import Grid from '@material-ui/core/Grid';
//import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import AddIcon from '@material-ui/icons/AddCircle';
import Popover from '@material-ui/core/Popover';
//import DisplayMode from './DisplayMode';
import PowerPicker from '../forms/PowerPicker';
import dsutils from './Utils';
const utils = dsutils();

/*
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
	pos: {
		marginBottom:12,
	},
	center : {
		textAlign: 'center'
	},
	interval : {
		textAlign: 'center',
		padding: 2,
		margin: 2,
		display: 'inline-block',
		maxWidth: 330,
		minWidth: 165,
	},
	powers : {
		maxWidth: 350,
		display: 'inline-block'
	},
	chip : {
			margin: theme.spacing(0.5),
			//fontSize:'0.9em'
		},
	
}));
*/

export default function PowerInterval(props) {
  	//const classes = useStyles();
	//Inherited props
  	const {type, label, onChange, intervals} = props;
	//Default state of popover
	const [powerPopper, setPowerPopper] = React.useState({
		open: false,
		anchor : null,
		interval : []
	});
	const [power, setPower] = React.useState([]);
	//update state on props changes
  	React.useEffect(() => {
	 	setPower(intervals);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

	//Add power interval Handler
	const handleAddInterval = (interval) => {
		let newPower = utils.control.interval.insert(interval, power);
		//update local
		setPower(newPower);
		//update parent, if available
		if(onChange){
			onChange(type, newPower);
		}
		closePop();
  	};
	//Remove power interval handler
	const handleDelInterval = (e, i) => {
		let newPower = Object.assign([], power);
		newPower.splice(i, 1);
		//update local
		setPower(newPower);
		//update parent, if available
		if(onChange){
			onChange(type, newPower);
		} 
	};
	//Open power interval popper
	const addInterval = (e) => {
		let times = [];
		if(power.length > 0){
			times.push(power[power.length - 1][1]);
			times.push(times[0]);
			console.log(times);
		}
		setPowerPopper({
			anchor: e.currentTarget,
			open:true,
			interval: times
		});
	}
	//Close power interval popper
	const closePop = () => {
		setPowerPopper({
			anchor: null,
			open : false,
			interval : []
		})
	}
	
	
	
	const displayText = (interval) => {
		return utils.control.time.pretty(interval[0])+' - '+utils.control.time.pretty(interval[1]);
	}
	
	const addButton = () =>{
		if(power.length < 6){
			return (
				<Chip label="Add" icon={<AddIcon />} variant="outlined" onClick={addInterval} /> 
			);
		}
		return '';
	}
	const powerIntervals = () => {
		if(power.length === 0){
			return (
				<div>
				<Chip label="On all day" />
				{addButton()}
				</div>
			);
		} else {
			return (
				<div>
				{power.map((row, i) => (
				 	<Chip
				 		key={i}
						label={displayText(row)}
						onDelete={(e) => {handleDelInterval(e, i)}}
					/>
				 ))}
				 {addButton()}
				</div>
			);
		}
	};
	
  	return (
		<div>
	  		<Typography variant="h6" component="h3">
	  			{label}
	  		</Typography>
			{powerIntervals()}
			<Popover
					id={type+'powerpopper'}
					open={powerPopper.open}
					anchorEl={powerPopper.anchor}
					onClose={closePop}
					anchorOrigin={{
								  vertical:'bottom',
								  horizontal: 'center'
								 }}
					transformOrigin={{
									 vertical:'top',
									 horizontal:'center'
									}}
				>
				<PowerPicker times={powerPopper.interval} onChange={handleAddInterval} intervals={power} />
			</Popover>
    	</div>
  	);
}

